import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/api/axios'
import { TWCTotalsResult } from '../types/totals'
import { PeriodTypeQuery, PeriodTypeView } from '@/types'
import { TWC_BASE_KEY, createQueryKey } from '@/api/query-keys'

export const TWC_TOTALS_KEY = createQueryKey({
  baseKey: TWC_BASE_KEY,
  keys: [`totals`]
})

const TWC_TOTALS_RESULTS_KEY = TWC_TOTALS_KEY.concat([`results`])

const getTWCTotalResults = async (params: {
  financialModelId: string
  period_type: PeriodTypeQuery
  view: PeriodTypeView
}): Promise<TWCTotalsResult> => {
  const response = await axiosInstance.get<TWCTotalsResult>(`/totals/`, {
    params: {
      financial_model_id: params.financialModelId,
      type: params.period_type,
      view: params.view
    }
  })
  return response.data
}

export const useGetTWCTotalResults = (params: { financialModelId: string; period_type: PeriodTypeQuery; view: PeriodTypeView }) =>
  useSuspenseQuery(
    queryOptions({
      queryKey: TWC_TOTALS_RESULTS_KEY.concat([params.financialModelId, params.period_type, params.view]),
      queryFn: () => getTWCTotalResults(params),
      staleTime: 0
    })
  )
